import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const WeightVerificationPopup = ({modalControl,data, onClose}) => {

    return <>
        <Modal
            className="fade bd-example-modal-lg"
            show={modalControl}
            size="md"
        >
            <Modal.Header>
                <Modal.Title>
                    {data?.ProductName}
                </Modal.Title>
                <Button variant="" className="btn-close" onClick={onClose}
                ></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <p>{data?.ShortDescription || 'Description Not Available' }</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    </>
}

export default WeightVerificationPopup